// Résumé de la synchronisation manuelle des photos e-commerce (miroir PrestaShop) :
// réponse de POST /stocks/product/:id/photos/sync -> { results: [{ store_id, status, added, removed, kept, errors }] }.

function plural(n, singulier, pluriel) {
    return n + ' ' + (n > 1 ? pluriel : singulier);
}

/**
 * Rend { level: 'info' | 'success' | 'warning' | 'error', lines: [texte] }.
 * Une ligne par boutique, puis ses erreurs. « error » si toutes les boutiques sont en erreur,
 * « warning » si au moins une l'est.
 */
export function summarizePhotoSync(body, status) {
    // « Aucune boutique jumelée » n'est dit que pour une réponse qui contient bien un tableau
    // `results` vide ; tout le reste (JSON illisible, 404 d'un ancien serveur) est une erreur.
    if (!body || !Array.isArray(body.results)) {
        return { level: 'error', lines: [syncFailureMessage(status, body)] };
    }
    const results = body.results;
    if (results.length === 0) {
        return { level: 'info', lines: ['Aucune boutique jumelée'] };
    }
    const lines = [];
    let enErreur = 0;
    results.forEach((r) => {
        const nom = r.store_id || 'boutique';
        const errors = Array.isArray(r.errors) ? r.errors.filter(Boolean) : [];
        if (r.status === 'error') {
            enErreur += 1;
        }
        if (r.status === 'skipped') {
            lines.push(nom + ' : produit absent de la boutique');
            return;
        }
        lines.push(
            nom + ' : ' + plural(r.added || 0, 'ajoutée', 'ajoutées')
            + ', ' + plural(r.removed || 0, 'supprimée', 'supprimées')
            + ', ' + plural(r.kept || 0, 'gardée', 'gardées')
            + (r.adopted > 0 ? ', ' + plural(r.adopted, 'image existante reprise', 'images existantes reprises') : '')
            + (r.imported > 0 ? ', ' + plural(r.imported, 'image importée', 'images importées') + ' depuis PrestaShop' : '')
            + (r.cover_set === true ? ', couverture mise à jour' : '')
        );
        errors.forEach((e) => lines.push('  Erreur : ' + e));
    });
    let level = 'success';
    if (results.every((r) => r.status === 'skipped')) {
        level = 'info';
    } else if (enErreur === results.length) {
        level = 'error';
    } else if (enErreur > 0 || lines.some((l) => l.startsWith('  Erreur'))) {
        level = 'warning';
    }
    return { level, lines };
}

// Corps de la requête : `confirm_empty` seulement si la fiche n'a aucune photo ET que l'utilisateur
// a coché la confirmation (la synchro supprimerait alors toutes les images MyJouleBox des boutiques).
// `adopt_all` : case « Reprendre aussi les images existantes de la boutique » (supprime aussi les
// images ajoutées à la main dans PrestaShop).
export function buildSyncBody(photoCount, confirmedEmpty, adoptAll) {
    const body = {};
    if (adoptAll === true) {
        body.adopt_all = true;
    }
    if (photoCount === 0 && confirmedEmpty) {
        body.confirm_empty = true;
    }
    return body;
}

export function syncErrorMessage(body, status) {
    if (body && body.code === 'empty_photos') {
        return "La fiche n'a aucune photo : cochez la confirmation pour supprimer les images envoyées par MyJouleBox.";
    }
    return syncFailureMessage(status, body);
}

// Synchro automatique à l'enregistrement des photos (« Modifier ») : storehouse ajoute `ecom_sync`
// à la réponse. Rend { level, text } pour un toast, ou null s'il n'y a rien à dire.
export function ecomSyncNotice(ecomSync) {
    if (ecomSync === 'started') {
        return { level: 'info', text: 'Photos envoyées aux boutiques PrestaShop en arrière-plan.' };
    }
    if (ecomSync === 'skipped_empty') {
        return {
            level: 'warning',
            text: "La fiche n'a plus de photo : les boutiques PrestaShop n'ont pas été modifiées. "
                + 'Utilisez « Synchroniser avec PrestaShop » pour retirer les images.',
        };
    }
    return null;
}

// « Synchronisation impossible (code HTTP 404) » + le message reçu s'il y en a un. `status` absent
// (erreur réseau) : pas de code.
export function syncFailureMessage(status, body) {
    const code = status ? ' (code HTTP ' + status + ')' : '';
    const detail = body && typeof body.error === 'string' ? body.error.trim() : '';
    return 'Synchronisation impossible' + code + (detail ? ' : ' + detail : '');
}

// Noms de fichiers des photos, dans l'ordre : `base_photos` envoyé par « Modifier photos » (liste telle
// que le dialogue l'a chargée à l'ouverture), pour que storehouse n'efface pas une photo importée
// depuis PrestaShop entre-temps.
export function photoFilenames(photos) {
    return (Array.isArray(photos) ? photos : [])
        .map((p) => p && p.filename)
        .filter((f) => typeof f === 'string' && f !== '');
}
